// Frontend entitlement helpers — mirror the backend (server.py is_member/is_pro).
// There is ONE paid plan: "Premium". "Member" = any active paid plan; it unlocks
// the whole Premium Access Matrix including the power features (multi-area gardens,
// data export). isPro is a back-compat alias of isMember (one plan, folded in).
const PAID_TIERS = ['premium', 'standard', 'pro'];

function trialActive(user) {
  if (!user || !user.subscription_trial || !user.trial_ends_at) return false;
  const ends = new Date(user.trial_ends_at).getTime();
  return !Number.isNaN(ends) && ends > Date.now();
}

export function isMember(user) {
  return !!(user && ((user.subscription_active && PAID_TIERS.includes(user.subscription_tier)) || trialActive(user)));
}

export function isPro(user) {
  return isMember(user);
}

// Premium-only web routes that free users should be redirected away from when
// deep-linked. (Sections with free value use the <PremiumGate> blur instead.)
export const PREMIUM_ROUTES = ['/scanner'];
export const PREMIUM_NAV_PATHS = ['/scanner'];
